module.exports = __webpack_public_path__ + "img/migration.5e17e5e7.png";